import util from '../util'

let controller = 'Favorecidos'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetFavorecidosPendentesAprovacao: function (dto) {
    return util.Axios.GetAll(controller + '/GetFavorecidosPendentesAprovacao', dto)
  },
  GetAllFavorecidosPix: function (dto) {
    return util.Axios.GetAll(controller + '/GetAllFavorecidosPix', dto)
  },
  AprovarFavorecidos: function (dto) {
    return util.Axios.Post(controller + '/AprovarFavorecidos', dto)
  },
  AprovarFavorecido: function (dto) {
    return util.Axios.Post(controller + '/AprovarFavorecido', dto)
  },
  RejeitarFavorecido: function (dto) {
    return util.Axios.Post(controller + '/RejeitarFavorecido', dto)
  },
  GetAllFavorecidosByConta: function (codigoConta) {
    return util.Axios.Get(controller + '/GetAllFavorecidosByConta', codigoConta)
  },
  PostContaFavorecido: function (dto) {
    return util.Axios.Post(controller + '/PostContaFavorecido', dto)
  },
  PutContaFavorecido: function (dto) {
    return util.Axios.Put(controller + '/PutContaFavorecido', '', dto)
  },
  ConsultarFraudeDocumento: function (dto) {
    return util.Axios.GetAll(controller + '/ConsultarFraudeDocumento', dto)
  },
})
